import React from "react";
import classNames from "classnames";
import { FilterSourceItem, FilterValues } from "./FilterValuesCollection";

interface ProductListProductStatusFilterProperties {
    readonly isActive: boolean;
    readonly productStatuses: FilterSourceItem[];
    readonly filter: FilterValues;
    readonly isSoldProductsPage: boolean;

    readonly onFilterChange: (filter: FilterValues) => void;
    readonly onActivateTab: () => void;
}

export default function ProductListProductStatusFilter({
    isActive,
    productStatuses,
    filter,
    isSoldProductsPage,
    onFilterChange,
    onActivateTab,
}: ProductListProductStatusFilterProperties): React.JSX.Element | undefined {
    if (productStatuses.length === 0 || isSoldProductsPage) {
        return undefined;
    }

    const handleFilterToggle = (statusId: number): void => {
        let currentStatuses: number[] = filter.ProductStatus ?? [];

        if (currentStatuses.includes(statusId)) {
            currentStatuses = currentStatuses.filter((id) => id !== statusId);
        } else {
            currentStatuses.push(statusId);
        }

        onFilterChange(Object.assign({}, filter, { ProductStatus: currentStatuses }));
    };

    return (
        <div className="filter-widget">
            <h2 className={isActive ? "active" : undefined} onClick={onActivateTab}>Stav zboží<i className="fa-solid fa-caret-down"></i></h2>

            <div className={classNames("widget-content", { hidden: !isActive })}>
                {productStatuses.map((productStatus) => <div className="filter-container" key={productStatus.id}>
                    <label htmlFor={`status_${productStatus.id}`}>
                        {productStatus.title}
                        <input
                            type="checkbox"
                            id={`status_${productStatus.id}`}
                            value={productStatus.id}
                            onChange={() => handleFilterToggle(productStatus.id)}
                            checked={filter.ProductStatus?.includes(productStatus.id)} />
                        <span className="checkmark"></span>
                        <span> ({productStatus.quantity}&times;)</span>
                    </label>
                </div>)}
            </div>
        </div>
    );
}
